// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Delete = React.forwardRef(function Delete(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></SvgIcon>;
});
export default Delete;
